<ion-card mode="ios" class="card-table-data" padding>

    <div class="lang-title">
        <h2>
            <ion-text color="primary">
                {{ 'manageVersion.configureMultilanguage' | translate }}
            </ion-text>
        </h2>
        <div class="lang-selection">
            <ion-button fill="clear" mode="ios" class="ion-no-padding"
                        (click)="changeSelectedLanguage('pt-BR')"
                        [ngClass]="{ 'active': selectedLanguage === 'pt-BR' }">
                PT
            </ion-button>
            <ion-button fill="clear" mode="ios" class="ion-no-padding"
                        (click)="changeSelectedLanguage('en-US')"
                        [ngClass]="{ 'active': selectedLanguage === 'en-US' }">
                EN
            </ion-button>
            <ion-button fill="clear" mode="ios" class="ion-no-padding"
                        (click)="changeSelectedLanguage('es-ES')"
                        [ngClass]="{ 'active': selectedLanguage === 'es-ES' }">
                ES
            </ion-button>
        </div>
    </div>

    <ng-container *ngIf="processConfig" [ngSwitch]="selectedLanguage">
        <div padding-bottom>
            <app-process-configuration
                    *ngSwitchCase="'pt-BR'"
                    [configuration]="processConfig.consentGoalsGlobalizationConfig['pt-BR']"
            ></app-process-configuration>

            <app-process-configuration
                    *ngSwitchCase="'en-US'"
                    [configuration]="processConfig.consentGoalsGlobalizationConfig['en-US']"
            ></app-process-configuration>

            <app-process-configuration
                    *ngSwitchCase="'es-ES'"
                    [configuration]="processConfig.consentGoalsGlobalizationConfig['es-ES']"
            ></app-process-configuration>
        </div>
    </ng-container>

    <div class="add-goal">
        <ion-button
                align-items-center
                mode="ios"
                color="secondary"
                id="newGoalButton"
                (click)="openManageGoalsInputModal()"
        >
            + {{ 'goalsInput.newGoalBtn' | translate }}
        </ion-button>
    </div>
    <ion-card-content class="ion-no-padding">
        <ion-grid class="table-view">
            <ion-row hidden-mobile class="header">
                <ion-col
                        *ngIf="processConfig?.title || processConfig?.description"
                        [size]="3"
                >
                    {{ 'generic.goal' | translate }}
                </ion-col>
                <ion-col *ngIf="processConfig?.weight" [size]="4">
                    {{ 'generic.weight' | translate }}
                </ion-col>
                <ion-col *ngIf="processConfig?.deadline" [size]="2">
                    {{ 'generic.deadline' | translate }}
                </ion-col>
                <ng-container *ngIf="processConfig?.questions">
                    <ion-col
                            [size]="getColumnSize(processConfig.questions.length)"
                            *ngFor="let question of processConfig.questions"
                    >
                        {{ getText(question.globalizationConfig, 'title') }}
                    </ion-col>
                </ng-container>
                <ion-col
                        [size]="getValidationColumnSize(processConfig?.questions.length)"
                >
                    {{ 'generic.validation' | translate }}
                </ion-col>
            </ion-row>

            <ion-row *ngFor="let goal of displayedGoals">
                <ion-col
                    *ngIf="processConfig?.title || processConfig?.description"
                    [size]="3"
                    class="ion-align-self-center"
                >
                    <div class="content">
                        <p class="label-heading" hidden-desktop>
                            {{ 'generic.goal' | translate }}
                        </p>
                        <h2 [id]="goal.title">{{ goal.title }}</h2>
                        <p class="underline-text">{{ goal.description }}</p>
                    </div>
                </ion-col>
                <ion-col
                    *ngIf="processConfig?.weight"
                    class="ion-align-self-center"
                    [size]="4"
                >
                    <p class="label-heading" hidden-desktop>
                        {{ 'generic.weight' | translate }}
                    </p>
                    {{ goal.weight }}%
                </ion-col>
                <ion-col
                    *ngIf="processConfig?.deadline"
                    class="ion-align-self-center"
                    [size]="2"
                >
                    <p class="label-heading" hidden-desktop>
                        {{ 'generic.deadline' | translate }}
                    </p>
                    {{ goal.deadline | date : 'dd/MM/yyyy' }}
                </ion-col>
                <ng-container>
                    <ion-col
                        class="ion-align-self-center"
                        [size]="getColumnSize(processConfig.questions.length)"
                        *ngFor="let question of processConfig.questions; let index = index"
                    >
                        <p class="label-heading" hidden-desktop>
                            {{ getText(question.globalizationConfig, 'title') }}
                        </p>
                        <ng-container
                                *ngIf="question.typeConfig.type === QuestionType.Date || question.typeConfig.type === QuestionType.Deadline"
                        >
                            {{
                                goal['field' + (index + 1)] | translate | date:'dd/MM/yyyy'
                            }}
                        </ng-container>
                        <ng-container *ngIf="question?.typeConfig?.type === QuestionType.Weight">
                            {{ goal['field' + (index + 1)] }} %
                        </ng-container>
                        <ng-container
                                *ngIf="question.typeConfig.type !== QuestionType.Date &&
                                     question.typeConfig.type !== QuestionType.Weight &&
                                     question.typeConfig.type !== QuestionType.Deadline"
                        >
                            {{
                                question.typeConfig?.possibleValuesGlobalized &&
                                question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                question.typeConfig?.possibleValues &&
                                question.typeConfig?.possibleValues?.length > 0
                                        ?
                                        question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal['field' + (index + 1)])]
                                        :
                                        (goal['field' + (index + 1)] | translate)
                            }}
                        </ng-container>
                    </ion-col>
                </ng-container>
                <ion-col class="validation"
                         [size]="getValidationColumnSize(processConfig?.questions.length)"
                >
                    <p class="label-heading" hidden-desktop>
                        {{ 'generic.actions' | translate }}
                    </p>
                    <div class="buttons validation">
                        <ng-container
                        >
                            <ion-button
                                    class="edit"
                                    color="primary"
                                    fill="clear"
                                    mode="ios"
                                    (click)="openManageGoalsInputModal(goal)"
                            >
                                <ion-icon class="bp-edit"></ion-icon>
                            </ion-button>
                            <ion-button
                                    class="delete"
                                    color="danger"
                                    fill="clear"
                                    mode="ios"
                                    (click)="confirmDeleteGoal(goal)"
                            >
                                <ion-icon class="bp-delete"></ion-icon>
                            </ion-button>
                        </ng-container>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>

<ion-footer>
    <ion-row>
        <div class="action-buttons">
            <ion-button
                    align-items-center
                    mode="ios"
                    color="danger"
                    id="cancelButton"
                    (click)="dismissModal()"
            >
                {{ 'generic.cancel' | translate }}
            </ion-button>
            <ion-button
                    align-items-center
                    mode="ios"
                    color="primary"
                    id="saveGoalButton"
                    (click)="saveGoals()"
            >
                {{ 'generic.save' | translate }}
            </ion-button>
        </div>
    </ion-row>
</ion-footer>